const baseUrlForRTM = "https://upm.sunrise.staging.squaredev.io";

const baseUrlForTT = "https://tt.sunrise.staging.squaredev.io"

const getOptions = (baseUrl, endPoint = "", token) => {
  return {
    url: `${baseUrl}${endPoint}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "text/html",
    },
  };
};

export { baseUrlForRTM, baseUrlForTT, getOptions };
